const positions = {
    topLeft: 'topLeft',
    top: 'top',
    topRight: 'topRight',

    left: 'left',
    center: 'center',
    right: 'right',

    bottomLeft: 'bottomLeft',
    bottom: 'bottom',
    bottomRight: 'bottomRight'
};

//For this to properly work; display block  + position relative is a requirement
const generateStyle = (
    position, 
    height
) => {
    const rules = [];

    let topPercentage = 0;

    //Force right
    if([positions.right, positions.topRight, positions.bottomRight].indexOf(position) !== -1){
        rules.push('float: right');
    }

    //Force left
    if([positions.left, positions.topLeft, positions.bottomLeft].indexOf(position) !== -1) {
        rules.push('float: left');
    }

    //Attempt to center horizontally via margin
    if([positions.center, positions.bottom, positions.top].indexOf(position) !== -1){
        rules.push('margin-left: auto; margin-right: auto;');
    }

    //Center vertically via top
    if([positions.left, positions.center, positions.right].indexOf(position) !== -1){
        //We need to divide by 2 for it to center
        topPercentage = 100 - height;

        //Never attempt to divide by 0 :-)
        if(topPercentage !== 0){
            topPercentage /= 2;
        }
    }

    if([positions.bottomLeft, positions.bottom, positions.bottomRight].indexOf(position) !== -1){
        topPercentage = 100 - height;
    }

    //Ensure we don't exceed 100/go below 0
    topPercentage = Math.min(Math.max(topPercentage, 0), 100);

    if(topPercentage){
        rules.push(`top: ${topPercentage}%`);
    }
    
    return rules.join(';');
};

export {
    generateStyle
};

export default positions;